import CashierServiceCollection from "../CashierServiceCollection";
import ProductModel from "../../models/cashier/ProductModel";

export default class ProductCollection extends CashierServiceCollection {

  model() {
    return ProductModel;
  }

  publicRoutes() {
    let model = (new (this.model())());
    return {
      fetch: process.env.VUE_APP_CASHIER_REPOSITORY_URL + '/api/v1/public/' + model.modelName(),
    }
  }

}
